import { Link } from "react-router-dom";
import Swal from "sweetalert2";

export default function Whishlist({title,image,price,type,onRemove,addToCart,addedToCart}) {

    const handleAddClick = () => {
      Swal.fire({
        icon: "success",
        title: "Added to Cart",
        text: "Product has been added to your cart!",
        showConfirmButton: true,
        timer: 3000,
      });
    };
    

  return (
    <tr>
      <td className="align-middle">
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            defaultValue
            id="chechboxTwo"
          />
          <label className="form-check-label" htmlFor="chechboxTwo"></label>
        </div>
      </td>
      <td className="align-middle">
        <Link to="#">
          <img
            src={image}
            className="img-fluid icon-shape icon-xxl"
            alt="product"
          />
        </Link>
      </td>
      <td className="align-middle">
        <div>
          <h5 className="fs-6 mb-0">
            <Link to="#" className="text-inherit">
              {title}
            </Link>
          </h5>
          <small>{type}</small>
        </div>
      </td>
      <td className="align-middle">₹{price}</td>
      <td className="align-middle">
        <span className="badge bg-success">In Stock</span>
      </td>
      <td className="align-middle">
        <button className="btn btn-primary btn-sm"
         onClick={addToCart}
         disabled={addedToCart}>
          {addedToCart?(
          <>
           <i className="bi bi-check-lg me-1"></i>
                Added to Cart
          </>
          ):(
         <>
          Add to Cart
         </>
          )}
          </button>
      </td>
      <td className="align-middle text-center">
        <Link
          to="#"
          onClick={onRemove}
          className="text-muted"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title="Delete"
        >
          <i class="fas fa-trash-alt"></i>
        </Link>
      </td>
    </tr>
  );
}
